import { client, getUrl } from "utils";

export const getConfigsRequest = (filterParams) => client.get(getUrl("primary-key/configs", filterParams));

export const getPlatformIDsRequest = () => client.get("primary-key/platform-ids");

export const createConfigRequest = (data) => client.post("primary-key/config", data);

export const validateConfigRequest = (data) => client.post("primary-key/config/validate", data);

export const editConfigRequest = (data) => client.put(`primary-key/config/${data.config?.platform_id}`, data);

export const getConfigExamplesRequest = (platformID) => client.get(`primary-key/config/${platformID}/examples`);

export const extractKeyRequest = (data) => client.post("primary-key", data);
